import { Injectable } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';
import { Base64 } from 'js-base64';
import * as CryptoJS from 'crypto-js';


@Injectable({
  providedIn: 'root'
})
export class CryptoService {

  constructor() {}

  generateUUID(): string {
    return uuidv4();
  }

  generateLongUUID(): string {
    return uuidv4() + uuidv4();
  }

  base64Encode(data: string): string {
    return Base64.encode(data);
  }

  base64URIEncode(data: string): string {
    return Base64.encodeURI(data);
  }

  sha256Hash(data: string): string {
    return CryptoJS.SHA256(data).toString(CryptoJS.enc.Base64);
  }

  generatePKCECodes() {
    const base64URLEncode = (str: CryptoJS.lib.WordArray) => {
      return CryptoJS.enc.Base64.stringify(str)
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=+$/, '');
    };

    const randomBytes = (length: number) => {
      const words: number[] = [];
      for (let i = 0; i < length; i += 4) {
        words.push(CryptoJS.lib.WordArray.random(4).words[0]);
      }
      return CryptoJS.lib.WordArray.create(words);
    };

    const verifier = base64URLEncode(randomBytes(32));

    const sha256 = (buffer: CryptoJS.lib.WordArray) => {
      return CryptoJS.SHA256(buffer);
    };

    const challenge = base64URLEncode(sha256(verifier));

    return {
      codeVerifier: verifier,
      codeChallenge: challenge
    };
  }
}
